<template>
  <path
    fill="none"
    stroke-width="1"
    stroke="rgba(0,0,0,0.6)"
    d="M 14.436993,94.986719
         c 5.516659,-2.012596 2.877715,-9.877917 3.549829,-14.661802
         c 0.245073,-4.595498 -1.506482,-12.628331 5.594171,-12.160598
         c 9.58673,2.311598 6.2608,16.429215 5.2959,23.9141
         c -1.995237,9.453821 -14.44536,14.682081 -22.0090997,8.191501
         c -8.3246292,7.32763 -21.9639333,0.12822 -22.9266743,-10.331451
         c -1.262547,-7.308088 -2.124112,-26.414962 10.1504745,-20.36445
         c 2.263083,4.968514 0.7822044,10.870253 1.2446,16.2687
         c -2.4518974,5.007827 4.94148652,14.256871 6.1975999,5.2832
         c -0.2934881,-7.165804 -4.3243146,-24.262154 7.9247999,-21.4376
         c 7.1546007,5.952038 -0.01938,17.965134 3.9623997,25.0825 z
         M 56.47558,82.337519
         c 9.713221,1.013622 2.016472,9.505437 -4.284229,7.0104
         c -4.593798,-1.331341 -4.976566,1.548348 -4.402571,5.3848
         c 5.018051,0.339018 10.282295,-0.718579 15.0876,0.9144
         c 4.824431,7.715341 -6.089552,7.717121 -11.132622,7.315201
         c -4.765504,-0.47006 -10.143489,1.23726 -14.318178,-1.5748
         c -2.519172,-6.210795 -0.915252,-13.286622 -1.3716,-19.904281
         c 0.446095,-4.599561 -1.858792,-11.922487 4.433888,-13.22367
         c 6.784205,-0.0855 13.614244,-0.309626 20.381912,0.13335
         c 8.853109,5.328301 -2.361246,9.596034 -8.071303,8.001
         c -4.268255,-0.941268 -6.09771,0.556266 -5.060497,4.920466
         c 0.44217,2.276643 6.480038,0.417157 8.7376,1.023134 z
         M 76.433625,102.96232
         c -7.952153,0.51188 -6.542026,-8.492375 -6.604,-13.774223
         c 0.403448,-6.108445 -0.915657,-12.529125 0.885825,-18.394878
         c 5.001142,-6.6083 13.206064,-0.0908 10.798175,6.836929
         c 0,5.514591 0,11.029181 0,16.543771
         c 4.259884,0.277245 8.753238,-0.707255 12.8016,0.8636
         c 4.931612,7.085411 -4.285974,8.823971 -9.543266,7.924801
         c -2.779445,0 -5.558889,0 -8.338334,0 z
         M 117.99358,77.714719
         c -6.46225,-8.524286 -12.60309,10.034708 -5.53085,14.043025
         c 5.60753,8.052504 19.37507,-10.200038 18.07845,2.466975
         c -6.60896,14.110791 -31.382886,11.153091 -33.629599,-4.6228
         c -3.228892,-11.754024 7.341289,-23.856516 19.469099,-21.656675
         c 11.99811,-1.91745 18.93945,17.65092 5.0165,19.218275
         c -6.31579,-0.008 -5.84291,-5.45647 -3.4036,-9.4488 z
         M 154.17349,95.850319
         c 8.58854,-1.820197 6.66295,-24.356659 -2.8448,-18.8976
         c -3.37109,5.209859 -4.20761,16.52 2.8448,18.8976 z
         m 8.9916,5.435601
         c -9.88888,5.1748 -24.79675,0.37867 -26.43584,-11.617326
          c-2.77875,-10.834615 5.91727,-22.742398 17.44424,-21.809075
          c 11.50748,-0.919012 20.28655,10.961735 17.4879,21.809075
          c -0.87877,4.881525 -4.01875,9.394753 -8.4963,11.617326 z
          M 208.00562,84.369519
          c -2.7545,5.071869 -4.61666,10.730165 -8.0772,15.341599
          c -6.30192,2.507382 -8.1516,-6.350282 -10.98384,-10.371895
          c -1.83911,-3.814448 -3.4046,-6.563221 -2.73216,-0.595956
          c -0.36367,4.386696 0.89747,9.160155 -1.016,13.203053
          c -7.68845,4.37441 -7.61568,-5.472348 -7.2136,-10.421424
          c 0.37052,-6.779132 -0.90226,-13.819009 1.00012,-20.369727
          c 4.97978,-6.90831 13.38054,-1.385072 14.68492,5.333848
          c 1.51112,3.304167 3.02224,6.608335 4.53336,9.912502
          c 2.83425,-5.378128 5.08311,-11.103876 8.34072,-16.2306
          c 7.33658,-6.384672 15.16945,2.224614 13.04608,10.037948
          c -0.23996,6.628765 0.50349,13.377474 -0.41593,19.924523
          c -5.32365,7.20997 -13.50889,-0.254421 -11.16647,-7.374738
          c 0,-2.796378 0,-5.592755 0,-8.389133 z
          M 246.77714,82.337519
          c 9.71322,1.013622 2.01647,9.505437 -4.28423,7.0104
          c -4.5938,-1.331341 -4.97656,1.548348 -4.40257,5.3848
          c 5.01805,0.339018 10.28229,-0.718579 15.0876,0.9144
          c 4.82443,7.715341 -6.08955,7.717121 -11.13262,7.315201
          c -4.76551,-0.47006 -10.14349,1.23726 -14.31818,-1.5748
          c -2.51917,-6.210795 -0.91525,-13.286622 -1.3716,-19.904281
          c 0.44609,-4.599561 -1.85879,-11.922487 4.43389,-13.22367
          c 6.7842,-0.0855 13.61424,-0.309626 20.38191,0.13335
          c 8.85311,5.328301 -2.36125,9.596034 -8.0713,8.001
          c -4.26826,-0.941268 -6.09771,0.556266 -5.0605,4.920466
          c 0.44217,2.276643 6.48004,0.417157 8.7376,1.023134 z
      "
  />
</template>

<script>
export default {
  name: 'WelcomeText'
}
</script>
